import React, { useState, useEffect } from 'react';
import AIThinkingComponent from '../components/ui/AIThinkingComponent';

const AIShowcase = () => {
    const [phase, setPhase] = useState('thinking'); // thinking, answering, complete
    const [results, setResults] = useState([]);

    useEffect(() => {
        if (phase === 'thinking') {
            const timer = setTimeout(() => {
                setPhase('answering');
            }, 4000);
            return () => clearTimeout(timer);
        }

        if (phase === 'answering') {
            const r1 = setTimeout(() => {
                setResults([{
                    title: "1. Vande Bharat Express (Train No. 22478)",
                    description: "Departure: 05:00 AM from Jammu Tawi. Arrival: 01:00 PM at New Delhi. Fastest connectivity with top-tier amenities."
                }]);
            }, 500);

            const r2 = setTimeout(() => {
                setResults(prev => [...prev, {
                    title: "2. Connecting Flight via New Delhi",
                    description: "Indigo 6E-2134 (Jammu to Delhi) + 6E-2451 (Delhi to Jabalpur). Total journey time approx. 4h 45m."
                }]);
            }, 4000);

            const r3 = setTimeout(() => {
                setPhase('complete');
            }, 8000);

            return () => {
                clearTimeout(r1);
                clearTimeout(r2);
                clearTimeout(r3);
            };
        }
    }, [phase]);

    const handleReset = () => {
        setPhase('thinking');
        setResults([]);
    };

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#0d0d0d',
            padding: '80px 24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: '#fff'
        }}>
            <div style={{ maxWidth: '800px', width: '100%' }}>
                <h2 style={{ marginBottom: '32px', fontSize: '1.25rem', fontWeight: 500, color: '#888' }}>
                    Video Reference Implementation
                </h2>

                <AIThinkingComponent
                    thinking_title="Finding travel routes from Jammu to Jabalpur"
                    thinking_desc="I'll search for all possible combinations: direct and connecting trains, bus options, plus any flights for January 21, 2026. Checking availability and pricing across multiple platforms..."
                    results={results}
                    isThinking={phase === 'thinking'}
                    thoughtDuration={phase !== 'thinking' ? "Thought for 4s" : null}
                    onAnswerNow={() => setPhase('answering')}
                />

                <div style={{ marginTop: '60px', textAlign: 'center' }}>
                    <button
                        onClick={handleReset}
                        style={{
                            backgroundColor: '#10a37f',
                            color: 'white',
                            border: 'none',
                            padding: '12px 28px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontWeight: 600,
                            fontSize: '0.9rem'
                        }}
                    >
                        Restart Sequence
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AIShowcase;
